import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = {
  key: 0,
  class: "tiptap-editor-toolbar"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Submit ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_BoldOutlined = _resolveComponent("BoldOutlined")!
  const _component_ItalicOutlined = _resolveComponent("ItalicOutlined")!
  const _component_AlignLeftOutlined = _resolveComponent("AlignLeftOutlined")!
  const _component_AlignCenterOutlined = _resolveComponent("AlignCenterOutlined")!
  const _component_AlignRightOutlined = _resolveComponent("AlignRightOutlined")!
  const _component_EditorContent = _resolveComponent("EditorContent")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { title: "Email Template" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        layout: "vertical",
        ref: "formRef",
        model: _ctx.form,
        id: "myForm"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_a_row, { gutter: [24,2] }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: { span: 24 },
                  sm: { span: 24 },
                  md: { span: 24 },
                  lg: { span: 6 }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "Template Name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: _ctx.form.template_name,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.template_name) = $event)),
                          id: "template_name"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: { span: 24 },
                  sm: { span: 24 },
                  md: { span: 24 },
                  lg: { span: 6 }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "Parameter" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.form.parameter,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.parameter) = $event)),
                          options: [
                            { label: 'Invoice #', value: 'Invoice #' },
                            { label: 'Check #', value: 'Check #' }
                            ],
                          "show-search": "",
                          filterOption: "filterOption",
                          optionFilterProp: "children",
                          id: "parameter"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: [24,2] }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: { span: 24 },
                  sm: { span: 24 },
                  md: { span: 24 },
                  lg: { span: 12 }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "Subject" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: _ctx.form.subject,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.subject) = $event)),
                          id: "subject"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: [24,2] }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: { span: 24 },
                  sm: { span: 24 },
                  md: { span: 24 },
                  lg: { span: 21 }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "Message" }, {
                      default: _withCtx(() => [
                        (_ctx.editor)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                              _createElementVNode("button", {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editor.chain().focus().toggleBold().run())),
                                class: _normalizeClass([{ 'is-active': _ctx.editor.isActive('bold') }, "tiptap-editor-btns"])
                              }, [
                                _createVNode(_component_BoldOutlined)
                              ], 2),
                              _createElementVNode("button", {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editor.chain().focus().toggleItalic().run())),
                                class: _normalizeClass([{ 'is-active': _ctx.editor.isActive('italic') }, "tiptap-editor-btns"])
                              }, [
                                _createVNode(_component_ItalicOutlined)
                              ], 2),
                              _createElementVNode("button", {
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editor.chain().focus().setTextAlign('left').run())),
                                class: _normalizeClass([{ 'is-active': _ctx.editor.isActive({ textAlign: 'left' }) }, "tiptap-editor-btns"])
                              }, [
                                _createVNode(_component_AlignLeftOutlined)
                              ], 2),
                              _createElementVNode("button", {
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editor.chain().focus().setTextAlign('center').run())),
                                class: _normalizeClass([{ 'is-active': _ctx.editor.isActive({ textAlign: 'center' }) }, "tiptap-editor-btns"])
                              }, [
                                _createVNode(_component_AlignCenterOutlined)
                              ], 2),
                              _createElementVNode("button", {
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editor.chain().focus().setTextAlign('right').run())),
                                class: _normalizeClass([{ 'is-active': _ctx.editor.isActive({ textAlign: 'right' }) }, "tiptap-editor-btns"])
                              }, [
                                _createVNode(_component_AlignRightOutlined)
                              ], 2)
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_EditorContent, {
                          editor: _ctx.editor,
                          value: _ctx.form.content,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.content) = $event)),
                          id: "content"
                        }, null, 8, ["editor", "value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_divider, { style: {"margin-bottom":"8px","margin-top":"5px"} }),
            _createVNode(_component_a_row, { gutter: [24,2] }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: { span: 24 },
                  sm: { span: 24 },
                  md: { span: 24 },
                  lg: { span: 21 }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "Message Preview" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          type: "text",
                          value: _ctx.form.preview,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.preview) = $event)),
                          id: "preview",
                          rows: 10,
                          "show-count": "",
                          disabled: true
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_a_form_item, { style: {"text-align":"right","margin-top":"40px","margin-bottom":"0"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    key: "back",
                    onClick: _ctx.back
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_a_button, {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSaving(_ctx.editor.getHTML()))),
                    type: "primary",
                    htmlType: "submit",
                    loading: _ctx.loading
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }))
}